<template>
  <main class="bg-mobile-white d-flex flex-lg-row flex-xxs-column align-items-lg-stretch remove-body-top-padding">
    <UserProfileSidebar
      :user="this.User"
      :is-navigation-visible="this.IsNavigationVisible"
      :active-tab="this.ActiveTab"
      @SetInitialData="SetInitialData"
    />
    <div
      class="d-flex flex-column mt-lg-5 mt-xxs-0 pt-4 col-xxl-7 col-xl-8 col-lg-9 col-xxs-12 px-2 pb-4"
      :class="{'mx-0':isNew}"
    >
      <UserProfileCongratulationsMessage v-if="(!isNew && !ProductsHistory && !isPaymentHistoryVisible) && ((this.IsNavigationVisible && this.ActiveTab == this.profileTab.ProductHistory) || !this.IsNavigationVisible)" />
      <CollectionGroupHost v-if="(!isNew && !ProductsHistory && !isPaymentHistoryVisible) && ((this.IsNavigationVisible && this.ActiveTab == this.profileTab.ProductHistory) || !this.IsNavigationVisible)" />
      <UserProfileNew
        v-if="isNew && !isPaymentHistoryVisible"
        :subscription-plans="SubscriptionPlans"
        :accounting="Accounting"
        :subscription-plan="SubscriptionPlan"
        :refer-url="ReferUrl"
        :is-navigation-visible="this.IsNavigationVisible"
        :active-tab="this.ActiveTab"
        :user="this.User"
        @ShowPaymentHistory="ShowPaymentHistory"
      />
      <UserProfileSubscribed
        v-if="!isNew && !isPaymentHistoryVisible"
        :user-activity="UserActivity"
        :products-history="ProductsHistory"
        :accounting="Accounting"
        :subscription-plan="SubscriptionPlan"
        :refer-url="ReferUrl"
        :is-navigation-visible="this.IsNavigationVisible"
        :active-tab="this.ActiveTab"
        @ShowPaymentHistory="ShowPaymentHistory"
      />
      <a
        v-if="isPaymentHistoryVisible"
        class="text-decoration-none text-dark align-self-start align-content-center my-3 mx-sm-5 mx-xxs-3 lead cursor-pointer"
        @click="HidePaymentHistory()"
      >
        <img height="30" class="bidi-icon" src="@/assets/icons/back.svg">
        {{ $t('common.back') }}
      </a>
      <UserProfilePaymentHistory
        v-if="isPaymentHistoryVisible"
        :payment-history="PaymentHistory"
        :subscription-plan="SubscriptionPlan"
        :accounting="Accounting"
      />
    </div>
    <UserProfileMobileBottomNavigation
      v-if="!isPaymentHistoryVisible"
      :active-tab="this.ActiveTab"
      :is-new="this.isNew"
      @ChangeTabToDemographic="ChangeTabToDemographic"
      @ChangeTabToWallet="ChangeTabToWallet"
      @ChangeTabToProductHistory="ChangeTabToProductHistory"
      @ChangeTabToSubscription="ChangeTabToSubscription"
    />
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserProfileSidebar from '@/components/UserProfileSidebar.vue'
import UserProfileNew from '@/components/UserProfileNew.vue'
import UserProfileSubscribed from '@/components/UserProfileSubscribed.vue'
import UserProfilePaymentHistory from '@/components/UserProfilePaymentHistory.vue'
import UserProfileMobileBottomNavigation from '@/components/UserProfileMobileBottomNavigation.vue'
import CollectionGroupHost from '@/components/CollectionGroupHost.vue'
import UserProfileCongratulationsMessage from '@/components/UserProfileCongratulationsMessage.vue'
import utility from '@/utilities/utility.js'
import enums from '@/utilities/enums.js'
import tabNavigation from '@/mixins/tabNavigation.js'

export default {
  name: 'UserProfile',
  components: {
    UserProfileSidebar,
    UserProfileNew,
    UserProfileSubscribed,
    UserProfilePaymentHistory,
    UserProfileMobileBottomNavigation,
    CollectionGroupHost,
    UserProfileCongratulationsMessage
  },
  mixins: [tabNavigation, enums],

  computed: {
    ...mapGetters({
      orderSubscriptionPlans: 'order/subscriptionPlans',
      userInfo: 'userDemographic/userInfo',
      isNew: 'subscription/isNewUser',
      isUnsubscribing: 'navigation/isUnsubscribing',
      paymentHistory: 'order/userPaymentHistory',
      userSubscriptions: 'subscription/userSubscriptions',
      userSubscriptionPlan: 'subscription/userSubscriptionPlan',
      isUserAuthenticated: 'auth/isUserAuthenticated'
    })
  },
  data () {
    return {
      isPaymentHistoryVisible: false,
      User: {},
      SubscriptionPlans: [],
      SubscriptionPlan: {
        // ActivePlan: "اشتراک سالانه",
        // RemainedDays: 90,
        // IsDailyPlan: false
      },
      ProductsHistory: {
        Title: 'بدون نیاز به دانلود',
        Configurations: {
          id: 59
        }
      },
      Accounting: {
        CurrentBalance: '',
        Unit: 'تومان'
      },
      UserActivity: {
        Month: 'بهمن',
        DownloadedAndroidGameCount: 28,
        WebGameCount: 14,
        SavedAmount: 54000,
        PriceType: 'ریال'
      },
      PaymentHistory: {
        PaymentItems: [
        ]
      },
      ReferUrl: 'http://bazili.com/referral/geo/xchfvkfgGlk76XHJkj'
    }
  },
  mounted () {
    this.DefaultTab = this.profileTab.Demographic
    this.SetInitialData()
  },
  methods: {
    ...mapActions({
      loadSubscriptionPlans: 'order/setSubscriptionPlans',
      loadUserInfo: 'userDemographic/loadUserInfo',
      loadUserSubscriptionStatus: 'subscription/getUserState',
      loadUserPaymentHistory: 'order/loadPaymentHistory',
      loadUserSubscriptionPlan: 'subscription/getUserSubscriptionPlan'

    }),
    SetGender (gender) {
      if (gender === true) {
        return this.$t('common.male')
      } else if (gender === false) {
        return this.$t('common.female')
      } else {
        return ''
      }
    },
    HidePaymentHistory () {
      this.isPaymentHistoryVisible = false
    },
    ShowPaymentHistory () {
      this.isPaymentHistoryVisible = true
    },
    ChangeTabToDemographic () {
      this.ActiveTab = this.profileTab.Demographic
    },
    ChangeTabToWallet () {
      this.ActiveTab = this.profileTab.Wallet
    },
    ChangeTabToProductHistory () {
      this.ActiveTab = this.profileTab.ProductHistory
    },
    ChangeTabToSubscription () {
      this.ActiveTab = this.profileTab.Subscription
    },
    setFakeData (user) {
      this.loadSubscriptionPlans()
      if (user === '989123515325') {
        (this.isNew = true),
        (this.SubscriptionPlan = {
          ActivePlan: '',
          RemainedDays: 0,
          IsDailyPlan: false
        })
      } else if (user === '2') {
        this.SubscriptionPlan = {
          ActivePlan: 'اشتراک روزانه',
          RemainedDays: 1,
          IsDailyPlan: true
        }
      } else if (user === '3') {
        (this.isNew = false),
        (this.UserActivity = null),
        (this.ProductsHistory = null)
      } else if (user === '4') this.isPaymentHistoryVisible = true
      else {
        this.isNew = false
      }
    },
    SetInitialData () {
      if (this.userInfo === undefined || this.userInfo.username === undefined) {
        this.loadUserInfo().then(response => {
          this.User = {
            FirstName: this.userInfo.firstName ? this.userInfo.firstName : '',
            LastName: this.userInfo.lastName ? this.userInfo.lastName : '',
            Biography: this.userInfo.bio ? this.userInfo.bio : '',
            UserName: this.userInfo.username ? this.userInfo.username : '',
            Nickname: this.userInfo.nickName ? this.userInfo.nickName : '',
            DateOfBirth: this.userInfo.birthDate ? this.userInfo.birthDate : '',
            Gender: '',
            Cellphone: this.userInfo.phoneNumber
              ? this.userInfo.phoneNumber
              : '',
            Email: this.userInfo.email ? this.userInfo.email : ''
          }
          this.User.Gender = this.SetGender(this.userInfo.gender)
          this.loadUserSubscriptionStatus()
          this.loadUserSubscriptionPlan(this.User.UserName).then(response => {
            this.SubscriptionPlan = response
          })
          this.loadUserPaymentHistory().then(response => {
            this.PaymentHistory.PaymentItems = response
          })
        })
      } else {
        this.User = {
          FirstName: this.userInfo.firstName ? this.userInfo.firstName : '',
          LastName: this.userInfo.lastName ? this.userInfo.lastName : '',
          Biography: this.userInfo.bio ? this.userInfo.bio : '',
          UserName: this.userInfo.username ? this.userInfo.username : '',
          Nickname: this.userInfo.nickName ? this.userInfo.nickName : '',
          DateOfBirth: this.userInfo.birthDate ? this.userInfo.birthDate : '',
          Gender: '',
          Cellphone: this.userInfo.phoneNumber ? this.userInfo.phoneNumber : '',
          Email: this.userInfo.email ? this.userInfo.email : ''
        }
        this.User.Gender = this.SetGender(this.userInfo.gender)
        this.loadUserSubscriptionStatus()
        this.loadUserSubscriptionPlan(this.User.UserName).then(response => {
          this.SubscriptionPlan = response
        })
        this.loadUserPaymentHistory().then(response => {
          this.PaymentHistory.PaymentItems = response
        })
      }

      if (this.orderSubscriptionPlans.length === 0) {
        this.loadSubscriptionPlans().then(response => {
          this.SubscriptionPlans = response
        })
      } else {
        this.SubscriptionPlans = this.orderSubscriptionPlans
      }
    }
  },
  watch: {
    isUnsubscribing: function () {
      if (this.isUnsubscribing === false) {
        this.SetInitialData()
      }
    }
  },
  created () {
    if (!this.isUserAuthenticated) {
      this.$ga.event('Registration', 'RedirectToLoginFromProfilePage')
      this.$router.push({ path: 'login' })
    }
    this.SetGender()
    this.DefaultTab = this.profileTab.Demographic
  }
}
</script>
